export const accounts = [
  {
    value: "6988900000",
    label: "6988900000"
  },
  {
    value: "7980000003",
    label: "7980000003"
  },
  {
    value: "6260000001",
    label: "6260000001"
  },
  {
    value: "6260000003",
    label: "6260000003"
  },
  {
    value: "6591000000",
    label: "6591000000"
  },
  {
    value: "6591000001",
    label: "6591000001"
  },
  {
    value: "7591000000",
    label: "7591000000"
  }
];

export const cecosByAccountSocietyAndDivision = {
  "6988900000": {
    "0051": {
      "1100": ["51R0000032", "51R0000039"],
      "0003": ["51R0000026", "51R0000033", "51R0000063", "51R0000065"],
      "0004": ["51R0000031", "51R0000038"],
      "0005": ["51R0000030", "51R0000037"],
      "0006": ["51R0000027", "51R0000034"],
      "0007": ["51R0000029", "51R0000036"],
      "0012": ["51R0000076", "51R0000077"],
      "0014": ["51R0000077", "51R0000035"]
    }
  },
  "7980000003": {
    "0051": {
      "1100": ["51R0000032", "51R0000039"],
      "0003": ["51R0000026", "51R0000033", "51R0000063", "51R0000065"],
      "0004": ["51R0000031", "51R0000038"],
      "0005": ["51R0000030", "51R0000037"],
      "0006": ["51R0000027", "51R0000034"],
      "0007": ["51R0000029", "51R0000036"],
      "0012": ["51R0000076", "51R0000077"],
      "0014": ["51R0000077", "51R0000035"]
    }
  },
  "6260000001": {
    "0001": {
      "0002": ["01R671"],
      "0004": ["01R667"],
      "0005": ["01R669"],
      "0008": ["01R179"]
    },
    "00L6": {
      "0300": ["L6R071"]
    },
    "00S0": {
      "0009": ["S0H921"]
    },
    "00Q8": {
      "1100": ["Q8RE0057"]
    },
    "1024": {
      "0006": ["56R460"],
      "0007": ["28R660"]
    }
  },
  "6260000003": {
    "00L6": {
      "0300": ["L6R071"]
    },
    "00Q8": {
      "1100": ["Q8RE0057"]
    },
    "1024": {
      "0006": ["56R460"],
      "0007": ["28R660"]
    }
  },
  "6591000000": {
    "1024": {
      "0012": ["60M300"],
      "0004": ["U7M001"],
      "0006": ["56M016"],
      "0007": ["24P640"],
      "0010": ["60N341"],
      "0014": ["24M640"],
      "0015": ["42M001"]
    },
    "0001": {
      "1100": ["01M249"],
      "0002": ["01G650"],
      "0003": ["01M640"],
      "0004": ["01M411"],
      "0005": ["01M633"],
      "0008": ["01M737"],
      "0014": ["01M934"]
    },
    "0011": {
      "0016": ["11M001"]
    },
    "0012": {
      "0014": ["12ES999999"]
    },
    "0021": {
      "0004": ["21ECOFIN01"]
    },
    "00S0": {
      "0005": ["50EST00001"],
      "0009": ["S0H921"]
    },
    "00D7": {
      "0001": ["D7M640"],
      "0002": ["D7M640"],
      "0014": ["D7M640"],
      "0003": ["D7M640"]
    }
  },
  "6591000001": {
    "00Q8": {
      "1100": ["Q8IN0606"],
      "0111": ["Q8IN0606"],
      "0113": ["Q8IN0606"],
      "0114": ["Q8IN0606"],
      "0115": ["Q8IN0606"],
      "0116": ["Q8IN0606"]
    }
  },
  "7591000000": {
    "1024": {
      "0012": ["60M300"],
      "0004": ["U7M001"],
      "0006": ["56M016"],
      "0007": ["24P640"],
      "0010": ["60N341"],
      "0014": ["24M640"],
      "0015": ["42M001"]
    },
    "0001": {
      "1100": ["01M249"],
      "0001": ["01T781"],
      "0002": ["01G650"],
      "0003": ["01M640"],
      "0004": ["01M411"],
      "0005": ["01M633"],
      "0008": ["01M737"],
      "0014": ["01M934"]
    },
    "0011": {
      "0016": ["11M001"]
    },
    "0012": {
      "0014": ["12ES999999"]
    },
    "0021": {
      "0004": ["21ECOFIN01"]
    },
    "00S0": {
      "0005": ["50EST00001"],
      "0009": ["S0H921"]
    },
    "00D7": {
      "0001": ["D7M640"],
      "0002": ["D7M640"],
      "0003": ["D7M640"],
      "0014": ["D7M640"]
    },
    "00Q8": {
      "1100": ["Q8IN0606"],
      "0111": ["Q8IN0606"],
      "0112": ["Q8IN0606"],
      "0113": ["Q8IN0606"],
      "0114": ["Q8IN0606"],
      "0115": ["Q8IN0606"],
      "0116": ["Q8IN0606"]
    }
  }
};
export default {
  accounts,
  cecosByAccountSocietyAndDivision
};
